import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@elotech/angular-common';
import {
  MovimentacaoRedutorCargaHorariaService
} from '../../../../folha-pagamento/src/movimentacao-pessoal/movimentacao-redutor-carga-horaria/movimentacao-redutor-carga-horaria.service';


@Injectable()
export class PortalMovimentacaoRedutorCargaHorariaService extends MovimentacaoRedutorCargaHorariaService {

  private readonly resourcePortal: string = '/api/portal-servidor/redutor-carga-horaria';

  constructor(private readonly httpClientPortal: HttpClient) {
    super(httpClientPortal);
  }

  public getPercentualReducao(funcionarioId: number): Observable<string> {
    return this.httpClientPortal.get({
      disableSpinner: true,
      resource: `${this.resourcePortal}/percentual-reducao/${funcionarioId}`
    });
  }
}
